const availableLanguages = [
	{ iso: 'fr', title: 'Français' },
	{ iso: 'en', title: 'English' },
];

export default availableLanguages;
